<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 12a12.01 12.01 0 1 0-12 12c6.08 0 12-4.77 12-12m-10.8.5h9.78a11 11 0 0 1-2.87 6.9zm9.78-1H12.54l-.04-.33V1.03A11 11 0 0 1 22.98 11.5M1 12A11 11 0 0 1 11.5 1.03v10.14c0 .67.26 1.3.73 1.77l7.17 7.17A11 11 0 0 1 12 23C5.94 23 1 18.07 1 12"/></svg>
</template>
